import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
`;

export const Tab = styled.div<{ isActive: boolean }>`
  position: relative;
  box-sizing: border-box;
  flex: 1;
  height: 74px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: ${({ theme, isActive }) =>
    isActive ? theme.primary : theme.COLORS.descText};
  border-bottom: ${({ theme, isActive }) =>
    isActive
      ? `2px solid ${theme.primary}`
      : `2px solid ${theme.COLORS.PrimaryBorder}`};
  font-size: 22px;
  font-weight: 600;

  @media ${media.desktop} {
    font-size: 18px;
  }

  @media ${media.mobile} {
    font-size: 16px;
    padding: 0 4px;
  }
`;

export const TabLayout = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  background: rgba(2, 118, 250, 0.1);
  filter: blur(30px);

  border-radius: 50%;

  z-index: -1;
`;
